import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { Token } from '../modules/domain/models/authentication/token';
import { AuthenticationDomainService } from '../modules/domain/services/authentication/authentication.domain.service';
import { ConfigService } from './config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private configService: ConfigService;
    private authenticationDomainService: AuthenticationDomainService;
    private tokenUpdate: Subject<void>;
    private httpClient: HttpClient;

    constructor(
        private router: Router,
        private injector: Injector) {
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.authenticationDomainService = this.injector.get(AuthenticationDomainService);

        if (!this.configService) {
            this.configService = this.injector.get(ConfigService);
        }

        if (!this.router) {
            this.router = this.injector.get(Router);
        }

        if (!this.httpClient) {
            this.httpClient = this.injector.get(HttpClient);
        }

        if (request.headers.has('no-auth')) {
            return next.handle(request.clone({ headers: request.headers.delete('no-auth') }));
        }
        const currentToken: Token = this.authenticationDomainService.getCurrentToken();

        if (this.tokenUpdate != null) {
            return this.tokenUpdate
                .mergeMap(() => {
                    return next.handle(this.getRequestOptionArgs(request));
                })
                .catch((error: any) => {
                    this.router.navigateByUrl('/login');
                    return Observable.throw(error);
                });
        }
        const usedToken: string = (!_.isNull(currentToken) && !_.isEmpty(currentToken)) ? currentToken.access_token : null;

        return next.handle(this.getRequestOptionArgs(request))
            .catch((error: any) => {
                if (error.status !== 401) { return Observable.throw(error); }

                if (_.isNull(currentToken) || _.isEmpty(currentToken)) {
                    this.router.navigateByUrl('/login');
                    return Observable.throw(error);
                }
                if (currentToken.access_token !== usedToken) {
                    // retry because undetected token update
                    return this.intercept(request, next);
                }

                return this.updateToken(currentToken.refresh_token)
                    .mergeMap(() => {
                        return next.handle(this.getRequestOptionArgs(request));
                    })
                    .catch(() => {
                        this.router.navigateByUrl('/login');
                        return Observable.throw(error);
                    });
            });
    }

    private getRequestOptionArgs(request: HttpRequest<any>): HttpRequest<any> {
        const currentToken: any = JSON.parse(localStorage.getItem('token'));
        if (currentToken) {
            request = request.clone({
                setHeaders: { 'Authorization': `${currentToken.token_type} ${currentToken.access_token}` }
            });
        }
        return request;
    }

    private updateToken(refreshToken: string): Observable<void> {
        if (this.tokenUpdate != null) {
            return this.tokenUpdate;
        }

        this.tokenUpdate = new Subject<void>();
        return this.authenticationDomainService.refreshtoken(refreshToken)
            .map((result: any) => {
                this.authenticationDomainService.storeToken(result);
                this.tokenUpdate.next();
                this.tokenUpdate = null;
            })
            .catch((error: any) => {
                localStorage.setItem('token', null);
                this.tokenUpdate.error(error);
                this.tokenUpdate = null;
                return Observable.throw(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/auth-interceptor.ts